import Tooltip from '@creditflowresearch/uilib/Tooltip';
import Button from '@creditflowresearch/uilib/Button';
import IconAnalytics from '@creditflowresearch/uilib/Icon/IconAnalytics';

interface IProps {
  onClick: () => void,
  isChartVisible: boolean,
}

const ChartShowButton = ({
  onClick,
  isChartVisible,
}: IProps) => (
  <Tooltip content={ isChartVisible ? 'Hide Charts' : 'Show Charts' }>
    <Button
      variant={ isChartVisible ? 'solid' : 'outline' }
      size="S"
      icon={ <IconAnalytics /> }
      onClick={ onClick }
      dataTest="ChartShowButton"
      ariaLabel={ isChartVisible ? 'Hide Charts' : 'Show Charts' }
    />
  </Tooltip>
);

export default ChartShowButton;
